import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class EngagementsDisengage extends ApplicationRecord {
  static jsonapiType = "engagements/disengage";

  @Attr() disengagedById: number;

  @Attr() engagementId: number;

  @Attr() message: string;
}

export default EngagementsDisengage;
